import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import profilesReducer from './profilesReducer';
import usersReducer from './usersReducer';
import collectionsReducer from './collectionsReducer';
import notificationReducer from './notificationReducer';
import treeReducer from './treeReducer';
import domainControllers from './domainControllersReducer';
import localDomains from './localDomainsReducer';
import agents from './agentsReducer';
import { ADapi } from '../services/ADapi';

export const store = configureStore({
  reducer: {
    profiles: profilesReducer,
    users: usersReducer,
    collections: collectionsReducer,
    notification: notificationReducer,
    tree: treeReducer,
    domainControllers: domainControllers,
    localDomains: localDomains,
    agents,
    // Add the generated reducer as a specific top-level slice
    [ADapi.reducerPath]: ADapi.reducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(ADapi.middleware);
  },
});

setupListeners(store.dispatch);
